module.exports = __webpack_public_path__ + "static/IBMPlexMono-Bold-e497c7d84d1cd863756c67d4772e18de.woff";